import { gql } from "@apollo/client";

export default {
  user: {
    name: "user",
    serviceName: "auth",
    query: gql`
      query {
        user {
          token
          roles
          lastname
          firstname
          cellphone
          media {
            full_url
            collection_name
          }
          wallet {
            balance
          }
          all_roles {
            shops {
              id
              title
            }
            units {
              id
              title
            }
            role {
              id
              name
              title
            }
          }
        }
      }
    `,
  },
};
